export default "/images/texrepublic.png?12445bff06316a7e77b3192fa47f665f";